"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isModelSimple = isModelSimple;
exports.wrapSchemaSimple = wrapSchemaSimple;
exports.wrapSchemaClass = wrapSchemaClass;
exports.wrapSchema = wrapSchema;
const vue_1 = require("vue");
const IOptions_1 = require("./IOptions");
const JSchema_1 = require("../JSchema");
const classToSchema_1 = require("../JSchema/classToSchema");
const defaultValue_1 = require("../JSchema/defaultValue");
const fixAndMergeSchema_1 = require("../JSchema/fixAndMergeSchema");
const fixData_1 = require("../JSchema/fixData");
const fixDateFormat_1 = require("../JSchema/fixDateFormat");
const gpdrData_1 = require("../JSchema/gpdrData");
const setData_1 = require("../JSchema/setData");
const deepCopy_1 = require("../methods/deepCopy");
const lang_1 = require("../methods/lang");
const _1 = __importDefault(require("."));
/**
 * czy to jest prosty model
 *
 * @export
 * @param {*} model model wejściowy
 * @param {number} [maxPropCount=100] maksymalna dopuszczalna liczba wlasciwości
 * @param {IRefCount} [refCount] informacje wewnętrzne
 * @returns {boolean} czy liczba włąsciwości nie przekaracza max
 */
function isModelSimple(model, maxPropCount = 100, count = 0) {
    if (model === undefined) {
        return true;
    }
    if (Array.isArray(model)) {
        count += model.length;
        if (count > maxPropCount)
            return false;
        for (const item of model) {
            if (!isModelSimple(item, maxPropCount, count)) {
                return false;
            }
        }
    }
    else if (typeof model === 'object' && model) {
        for (const key in model) {
            if (!isModelSimple(model[key], maxPropCount, count)) {
                return false;
            }
        }
    }
    else {
        if (++count > maxPropCount)
            return false;
    }
    return true;
}
function wrapSchemaSimple(schema, model = null, options = {}) {
    schema = (0, vue_1.unref)(schema);
    // proste naprawianie root
    if (!schema.type && schema.properties) {
        schema.type = 'object';
    }
    return wrapSchema(schema, model, Object.assign(Object.assign({}, options), { skipFix: true }));
}
function wrapSchemaClass(
// schema: T | T[],
schemaClass, model = null, options = {}) {
    return wrapSchemaSimple((0, classToSchema_1.classToSchema)(schemaClass, options.defaultsFromInstance), model, options);
}
function wrapSchema(
// schema: T | T[],
schema, model = null, options = {}) {
    // console.log('wrap');
    var _a, _b;
    // napraw schema, rozwią refs i dodaj $parent
    // const stime = new Date().getTime();
    // console.log('fixSchema', new Date().getTime() - stime);
    // czyszczenie opcji, spoza ioptions
    // const arrayItemGuidField = options.arrayItemGuidField;
    const onAfterSchema = options.onAfterSchema;
    const onBeforeFixSchema = options.onBeforeFixSchema;
    const onBeforeWrap = options.onBeforeWrap;
    const vm = options.vm;
    delete options.arrayItemGuidField;
    delete options.onAfterSchema;
    delete options.onBeforeFixSchema;
    delete options.onBeforeWrap;
    delete options.vm;
    let schemaMethodsOrg = true;
    const app = vm ? vm._.appContext.app : null;
    let fixedSchema;
    schema = (0, vue_1.unref)(schema);
    if (options.skipFix) {
        if ((0, vue_1.isProxy)(schema)) {
            fixedSchema = (0, deepCopy_1.deepCopy)(schema);
        }
        else {
            fixedSchema = schema;
        }
    }
    else {
        // fix schema options
        const fixOptions = Object.assign({}, fixAndMergeSchema_1.fixSchemaDefaultOptions);
        if (options.arrayItemGuidField !== undefined) {
            fixOptions.arrayItemGuidField = options.arrayItemGuidField;
        }
        else {
            if (schema.$options && schema.$options.arrayItemGuidField !== undefined) {
                fixOptions.arrayItemGuidField = schema.$options.arrayItemGuidField;
            }
        }
        fixOptions.model = model;
        if (onBeforeFixSchema) {
            onBeforeFixSchema.call(vm, schema, fixOptions);
        }
        if (Array.isArray(schema)) {
            fixedSchema = (0, JSchema_1.fixAndMergeSchema)(schema, fixOptions);
        }
        else if (schema.$parent === undefined) {
            fixedSchema = (0, JSchema_1.fixAndMergeSchema)([schema], fixOptions);
        }
        else {
            fixedSchema = schema;
        }
    }
    const soptions = (0, IOptions_1.fixSchemaOptions)();
    // połączenie metdos
    let extraMethods = null;
    // ze scheamtu
    if (fixedSchema.$options) {
        if (fixedSchema.$options.$methods) {
            extraMethods = Object.assign(extraMethods || {}, fixedSchema.$options.$methods);
            // (fixedSchema.$options as any).$methods = undefined;
        }
        (0, IOptions_1.mergeOptions)(soptions, fixedSchema.$options);
    }
    if (fixedSchema.$methods) {
        extraMethods = Object.assign(extraMethods || {}, fixedSchema.$methods);
    }
    // z opcji
    if (options.schemaMethods) {
        extraMethods = Object.assign(extraMethods || {}, options.schemaMethods);
    }
    (0, IOptions_1.mergeOptions)(soptions, options);
    soptions._disabledFields = undefined;
    soptions._forceRecalc = soptions.forceCalcEnabled ? (0, vue_1.ref)(0) : undefined;
    soptions._anyEvent = undefined;
    soptions._readedErrorFields = undefined;
    if (extraMethods) {
        let areMethods = false;
        for (const method in extraMethods) {
            if (Object.prototype.hasOwnProperty.call(extraMethods, method)) {
                const element = extraMethods[method];
                if (element instanceof Function) {
                    // extraMethods[method] = element;
                    if (vm) {
                        // ustawienie this na instancję vm
                        extraMethods[method] = function () {
                            // eslint-disable-next-line prefer-rest-params
                            return element.apply(vm || this, arguments);
                        };
                    }
                    else {
                        extraMethods[method] = element;
                    }
                }
                else if (typeof element === 'object' && method.toLocaleLowerCase().endsWith('service')) {
                    extraMethods[method] = element;
                }
                else {
                    let methodText = element;
                    let methodsProps = '$0,$1,$2,$3,$4,$5,$6,$7,$8,$9';
                    const props = element.props || element.args;
                    const body = element.body || element.text;
                    if (props) {
                        methodsProps = props || '';
                    }
                    if (body) {
                        methodText = body;
                    }
                    if (Array.isArray(methodText)) {
                        methodText = methodText.join('\n');
                    }
                    if (typeof methodText === 'string') {
                        extraMethods[method] = new Function(methodsProps, methodText);
                    }
                    else {
                        extraMethods[method] = element;
                    }
                }
                areMethods = true;
            }
        }
        if (areMethods) {
            // vm.$methods = soptions.Vue.prototype.$methods = soptions.schemaMethods = Object.assign({}, defaultOptions.schemaMethods, extraMethods);
            soptions.schemaMethods = Object.assign({}, IOptions_1.defaultOptions.schemaMethods, extraMethods);
            schemaMethodsOrg = false;
            // vm.$methods = soptions.Vue.prototype.$methods = soptions.schemaMethods;
        }
    }
    //lang
    let lang = soptions.lang;
    // debugger;
    const instance = (0, vue_1.getCurrentInstance)();
    let onChangeLanguage = undefined;
    // let translate: II18N["t"] = undefined;
    let i18n = soptions.i18n;
    if (i18n) {
        //translate = i18n.t;
    }
    else if (!i18n && instance && instance.appContext) {
        //próbuj z instancji
        i18n = (_b = (_a = instance.appContext.config) === null || _a === void 0 ? void 0 : _a.globalProperties) === null || _b === void 0 ? void 0 : _b.$i18next;
    }
    //dodawanie metody translate
    if (i18n) {
        // debugger;
        const translate = i18n.t;
        // const changeLanguage = i18n.changeLanguage;
        const i18lang = i18n.language;
        //_lang.translate = translate;
        if (schemaMethodsOrg) {
            soptions.schemaMethods = Object.assign({}, soptions.schemaMethods, {
                translate
            });
            schemaMethodsOrg = false;
        }
        else {
            soptions.schemaMethods.translate = translate;
        }
        // var translate = i18n.t;
        onChangeLanguage = (lang) => {
            // console.log("onChangeLanguage", lang);
            if (soptions._i18n) {
                soptions._i18n.value = {
                    t: translate,
                    language: lang,
                    instance: i18n
                };
            }
            // jeśli nie było wymuszenia ręcznego
            if (!soptions.lang) {
                if (mainprop) {
                    return mainprop.$changeLanguage(lang, true);
                }
                else if (soptions._lang) {
                    soptions._lang.value = (0, lang_1.createLang)(lang);
                    return true;
                }
            }
            return false;
        };
        i18n.on('languageChanged', onChangeLanguage); //trik na toRaw
        //_lang.i18n = i18n;
        soptions._i18n = (0, vue_1.shallowRef)({
            t: translate,
            language: i18lang,
            instance: i18n
        });
        // jeśli lang nie było wymuszone przez options.lang
        if (!lang) {
            lang = i18lang;
        }
        // soptions.schemaMethods.translate = (key: string, options?: any) => soptions.i18n?.t(key, options);
    }
    if (lang) {
        soptions._lang = (0, vue_1.shallowRef)((0, lang_1.createLang)(lang));
    }
    else {
        soptions._lang = (0, vue_1.shallowRef)(soptions.schemaMethods.lang);
    }
    if (schemaMethodsOrg) {
        soptions.schemaMethods = Object.assign({}, soptions.schemaMethods);
        schemaMethodsOrg = false;
    }
    if (soptions._lang) {
        Object.defineProperty(soptions.schemaMethods, 'lang', {
            enumerable: true,
            get() {
                var _a;
                return (_a = soptions._lang) === null || _a === void 0 ? void 0 : _a.value;
            }
        });
    }
    // ustawienie $method w app
    if (app) {
        app.config.globalProperties.$methods = soptions.schemaMethods;
    }
    // ustawienie $methods w instacji
    if (vm) {
        vm.$methods = soptions.schemaMethods;
    }
    // fix model
    if (model == null) {
        if (soptions.fixData) {
            model = (0, defaultValue_1.defaultValue)(fixedSchema, true, undefined, soptions);
        }
        else {
            model = {};
        }
    }
    else {
        if (options.gdprMode) {
            model = (0, gpdrData_1.gdprData)(fixedSchema, model, options.gdprMode);
        }
        if (soptions.fixData && !soptions.fixTypes) {
            if (process.env.NODE_ENV !== 'production') {
                // tslint:disable-next-line: no-console
                // console.time('fixData');
            }
            const fixed = (0, fixData_1.fixData)(fixedSchema, model, true, soptions);
            if (process.env.NODE_ENV !== 'production') {
                // tslint:disable-next-line: no-console
                // console.timeEnd('fixData');
                if (fixed) {
                    // tslint:disable-next-line: no-console
                    // console.log('fixed fields: ' + fixed);
                }
            }
        }
        if (soptions.fixTypes) {
            if (process.env.NODE_ENV !== 'production') {
                // tslint:disable-next-line: no-console
                console.time('fixTypes');
            }
            // const fixed2 = fixDateFormat(fixedSchema, model);
            const newModel = {};
            (0, setData_1.setData)(fixedSchema, newModel, model, null, 0, true, soptions);
            model = newModel;
            if (soptions.fixData)
                (0, fixData_1.fixData)(fixedSchema, model, true, soptions);
            if (process.env.NODE_ENV !== 'production') {
                // tslint:disable-next-line: no-console
                console.timeEnd('fixTypes');
                /*
                if (fixed2) {
                  // tslint:disable-next-line: no-console
                  console.log('fixed format fields: ' + fixed2);
                }
                */
            }
        }
        else if (soptions.fixFormat) {
            if (process.env.NODE_ENV !== 'production') {
                // tslint:disable-next-line: no-console
                console.time('fixFormat');
            }
            const fixed2 = (0, fixDateFormat_1.fixDateFormat)(fixedSchema, model);
            (0, setData_1.setData)(fixedSchema, model, model, null, 0, true, soptions);
            if (process.env.NODE_ENV !== 'production') {
                // tslint:disable-next-line: no-console
                console.timeEnd('fixFormat');
                if (fixed2) {
                    // tslint:disable-next-line: no-console
                    console.log('fixed format fields: ' + fixed2);
                }
            }
        }
    }
    if (soptions.wrapAll === undefined) {
        soptions.wrapAll = isModelSimple(model, 100);
    }
    // this.calcFunctions = [];
    // this.summaryFunctions = [];
    if (!(0, vue_1.isReactive)(model)) {
        model = (0, vue_1.reactive)(model);
    }
    //zrobienie readonly z $external
    if (options.external) {
        if (!(0, vue_1.isReactive)(options.external)) {
            options.external = (0, vue_1.readonly)(options.external);
        }
    }
    if (onBeforeWrap) {
        onBeforeWrap.call(vm, model, fixedSchema, soptions);
    }
    if (process.env.NODE_ENV !== 'production') {
        // tslint:disable-next-line: no-console
        // console.time('wrapping schema');
    }
    soptions._disabledFields = new Set();
    soptions._anyEvent = {};
    const mainprop = new _1.default['object']({
        dest: null,
        parent: { model },
        prevModel: options.prevModel ? options.prevModel : undefined,
        propName: 'model',
        schema: fixedSchema,
        options: soptions
    });
    if (process.env.NODE_ENV !== 'production') {
        // tslint:disable-next-line: no-console
        // console.timeEnd('wrapping schema');
    }
    if (onAfterSchema) {
        onAfterSchema.call(vm, mainprop);
    }
    mainprop._internal.onDestroy = () => {
        if (onChangeLanguage && i18n) {
            console.log('offChangeLanguage');
            i18n.off('languageChanged', onChangeLanguage);
        }
    };
    try {
        if (instance) {
            // ustawienie $methods
            if (!instance.appContext.app.config.globalProperties.$methods) {
                instance.appContext.app.config.globalProperties.$methods = IOptions_1.defaultOptions.schemaMethods;
            }
            (0, vue_1.onBeforeMount)(() => {
                try {
                    const instance = (0, vue_1.getCurrentInstance)();
                    if (instance && instance.ctx && !instance.ctx.$schema) {
                        instance.ctx.$schema = mainprop;
                    }
                    //eslint-disable-next-line no-empty
                }
                catch (_a) { }
            });
            (0, vue_1.onBeforeUnmount)(() => {
                try {
                    const instance = (0, vue_1.getCurrentInstance)();
                    if (instance && instance.ctx && instance.ctx.$schema) {
                        const prop = instance.ctx.$schema;
                        prop.$destroy();
                        delete instance.ctx.$schema;
                        delete instance.ctx.schema;
                    }
                    /*
                    if (onChangeLanguage && i18n) {
                      console.log('offChangeLanguage');
                      i18n.off('languageChanged', onChangeLanguage);
                    }
                      */
                    //eslint-disable-next-line no-empty
                }
                catch (_a) { }
            });
        }
        //eslint-disable-next-line no-empty
    }
    catch (_c) { }
    // Object.seal(mainprop);
    return mainprop;
}
exports.default = wrapSchema;
//# sourceMappingURL=wrapSchema.js.map